import { useState, useEffect } from "react";

import { useParams, useNavigate } from 'react-router-dom';


// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import MDBadge from "components/MDBadge";
import MDInput from "components/MDInput";
import MDPopup from "components/MDPopup";
import MDAlert from "components/MDAlert";

import MDSelect from "components/MDSelect";

import { Link } from "react-router-dom";

import { jsPDF } from "jspdf";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

import TicketNote from "./ticketNote";

import Icon from "@mui/material/Icon";

import { useAuthContext } from "../../../hooks/useAuthContext";

import { httpGet, httpPost, httpPatch } from "../../../api";

import { DownloadFile, formatDate, FileToB64, ExportMessages } from "../../../utils";

const UserPage = () => {
  const { user } = useAuthContext();

  const navigate = useNavigate();

  const { id } = useParams();


  const [messages, setMessages] = useState([]);
  const [renderedMessages, setRenderedMessages] = useState([])

  const [ticketInfo, setTicketInfo] = useState({});

  const [refreshed, setRefreshed] = useState(true);



  const [newMessage, setNewMessage] = useState("");
  const [newAttachment, setNewAttachment] = useState(null);

  const [canSubmit, setCanSubmit] = useState(false);

  const [canWrite, setCanWrite] = useState(true);

  const [openNote, setOpenNote] = useState(false);

  const handleCloseNote = () => {
    setOpenNote(false);
  }

  const handleCloseNoted = (n) => {
    navigate("/tickets");
  }

  useEffect(() => {
    const fetchData = async () => {
      const response = await httpGet(process.env.REACT_APP_URL_BASE + "/ticket/id/" + id);

      if (response.success == false){
            return
      }

      setMessages(await response.json());

      setRefreshed(false);
    };
    if (refreshed) {
      fetchData();

      // clear the input
      setNewMessage("");
      setNewAttachment(null);

      document.getElementById("new_message").value = "";
      document.getElementById("new_attachment").value = "";
    }
  }, [refreshed]);


  useEffect(() => {
    if (messages.length == 0){
      return
    }

    setTicketInfo({
      id: messages[0].ticket_id,
      title: messages[0].title,
      description: messages[0].description,
      status: messages[0].status,
      level: messages[0].level,
      note: messages[0].note
    })

    const _messages = [];

    messages.forEach((message) => {
      if (message.user_id == null){
        return
      }

      var _style1 = {}
      var _style2 = {position: "relative", width: "70%", margin: ".5em 0", padding: "1em", borderRadius: "0.8em"}

      var _color1 = ""
      var _color2 = "text"

      var _color3 = "dark"

      var download = message.attachment == null ? "" : <><br />
            <MDBadge color="warning" onClick={(e) => {handleDownloadFile(message.id, message.attachment)}} badgeContent={<><Icon fontSize="small" sx={{margin: "0 .2em 0 0"}}>download</Icon>{message.attachment}</>} variant="gradient" size="lg" container sx={{cursor: "pointer", margin: ".5em 0 0 0"}}/></>

      if (message.user_id == user.id){
        _style1 = {display: "flex", justifyContent: "end"}
        _style2.backgroundColor = "#636e72"

        _color1 = "white"
        _color2 = "white"

        _color3 = "white"
      }else{
        _style2.backgroundColor = "#dfe6e9"
      }

       _messages.push(
        <MDBox sx={_style1}>
          <MDBox sx={_style2}>
            <MDTypography variant="h5" color={_color1}>
              {message.first_name + " " + message.second_name} :
            </MDTypography>
            <MDTypography variant="p" color={_color2}>
              {message.content}
            </MDTypography>

            {download}

            <MDTypography variant="label" color={_color3} sx={{fontSize: "0.7em", bottom: "0em", position: "absolute", right: "1em"}}>
              {formatDate(new Date(message.date_created))}
            </MDTypography>
          </MDBox>
        </MDBox>)
    })

    setRenderedMessages(_messages)

  }, [messages]);

  useEffect(() => {
    //scroll to bottom

    document.getElementById("messages_holder").scrollTop = document.getElementById("messages_holder").scrollHeight
  }, [renderedMessages])

  //handle submit


  useEffect(() => {
    setCanWrite(
     ticketInfo.status != "closed" && ticketInfo.status != "treated"
    )
  }, [ticketInfo])


  useEffect(() => {

    setCanSubmit(
      canWrite && newMessage.trim() != ""
    )
    
  }, [newMessage, newAttachment]);

  const handleCloseTicket = async () => {
    if(window.confirm("Are you sure you want to close this ticket?")){
      httpPatch(process.env.REACT_APP_URL_BASE + "/ticket/closeStatus/", {
        id
      }).then((response) => { 
        if (response.status === 200) {
          setOpenNote(true);
        }else{
          alert("Something went wrong");
          console.log(response);
        }
      });
    }
  }

  const handleSubmit = async () => {
    const attachment = {}

    if (newAttachment != null){
      attachment.attachment_data = await FileToB64(newAttachment)
      attachment.attachment_name = newAttachment.name
      attachment.attachment_exists = true
    }else{
      attachment.attachment_exists = false
    }

    httpPost(process.env.REACT_APP_URL_BASE + "/message/create", {
      ticket_id: id,
      content: newMessage.trim(),
      attachment: attachment
    }).then((response) => {
      if (response.status === 201) {
        // refresh the page
        // we can just append the new to message state but we prefer we fetch

        setRefreshed(true);
      }else{
        alert("Something went wrong");

        console.log(response);
      }
    });
  }

  const handleDownloadFile = async (message_id, file_name) => {
    const response = await httpGet(process.env.REACT_APP_URL_BASE + "/message/files/" + message_id);

    if (response.status === 200) {
      const blob = await response.blob();

      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', file_name);

      document.body.appendChild(link);

      link.click();

      
    }else {
      alert("Something went wrong");

      console.log(response);
    }
  }

  const handleExport = async () => {
    ExportMessages(messages, "ticket_export")
  };



  return ( 
    <>
    <DashboardLayout>
      <TicketNote ticket={id} open={openNote} close={handleCloseNote} setRefreshed={handleCloseNoted} />

      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="error"
                borderRadius="lg"
                coloredShadow="info"
                sx={{textAlign: "center", display: "flex", justifyContent: "space-between", alignItems: "center", boxShadow: "white 0 1em 20px", zIndex: "2"}}
              >
                <MDTypography variant="h3" color="white">
                  {ticketInfo.title}
                </MDTypography>
                {user.role === "user" && ["open", "progress"].includes(ticketInfo.status) && (
                  <MDButton onClick={handleCloseTicket} variant="gradient" color="warning">
                    Close the ticket
                  </MDButton>
                  )}

                {user.role !== "user" && (
                  <MDButton onClick={handleExport} variant="gradient" color="warning">
                    Export
                  </MDButton>
                  )}
              </MDBox>
              <MDBox p={3} id="messages_holder" sx={{height: "50vh", overflow: "auto"}}>

              {renderedMessages}
                  
              </MDBox>

              <MDBox sx={{display: "flex", justifyContent: "space-between", alignItems: "start", margin: "2em 0 0 0"}}>
                <MDInput 
                  multiline 
                  rows={10} 
                  placeholder="Write your message ..." 
                  autofocus 
                  type="text" 
                  sx={{width: "85%", margin: ".5em"}} 
                  
                  disabled={!canWrite}

                  id="new_message"

                  onChange={(e) => {
                    setNewMessage(e.target.value)
                  }}

                />

                <MDBox sx={{width: "15%", margin: "0 .5em"}}>

                  <MDTypography 
                    variant="label" 
                    color="text"
                  >
                    Attach files :
                  </MDTypography>

                  <MDInput type="file"
                    disabled={!canWrite}

                    id="new_attachment"

                    onChange={(e) => {
                      setNewAttachment(e.target.files[0])
                    }} />

                  <MDButton variant="gradient" onClick={handleSubmit} disabled={!canSubmit} color="info" sx={{margin: ".5em 0", width: "100%", height: "5em", fontSize: "1em"}}>
                    Send
                  </MDButton>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
    </>

  )
}

export default UserPage